var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.75C6 9.05964 6.55964 8.5 7.25 8.5H10.75C11.4404 8.5 12 9.05964 12 9.75V11.75C12 12.4404 11.4404 13 10.75 13H7.25C6.55964 13 6 12.4404 6 11.75V9.75ZM7.5 10V11.5H10.5V10H7.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.25C14 8.83579 14.3358 8.5 14.75 8.5H19.25C19.6642 8.5 20 8.83579 20 9.25C20 9.66421 19.6642 10 19.25 10H14.75C14.3358 10 14 9.66421 14 9.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12.25C14 11.8358 14.3358 11.5 14.75 11.5H19.25C19.6642 11.5 20 11.8358 20 12.25C20 12.6642 19.6642 13 19.25 13H14.75C14.3358 13 14 12.6642 14 12.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 15.25C6 14.8358 6.33579 14.5 6.75 14.5H11.25C11.6642 14.5 12 14.8358 12 15.25C12 15.6642 11.6642 16 11.25 16H6.75C6.33579 16 6 15.6642 6 15.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15.25C14 14.8358 14.3358 14.5 14.75 14.5H19.25C19.6642 14.5 20 14.8358 20 15.25C20 15.6642 19.6642 16 19.25 16H14.75C14.3358 16 14 15.6642 14 15.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 19.75H3V18.75H6V19.75Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 7.00071C3.25 5.48227 4.48087 4.25 6 4.25H20C21.5188 4.25 22.75 5.48122 22.75 7V17C22.75 18.5193 21.5173 19.75 19.999 19.75H4V18.25H19.999C20.6899 18.25 21.25 17.6899 21.25 17V7C21.25 6.30964 20.6904 5.75 20 5.75H6C5.30999 5.75 4.75 6.31001 4.75 7.00071L4.75 10.4999L3.25 10.5L3.25 7.00071Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 9C3.25 8.86193 3.13807 8.75 3 8.75C2.86193 8.75 2.75 8.86193 2.75 9V18C2.75 18.1381 2.86193 18.25 3 18.25C3.13807 18.25 3.25 18.1381 3.25 18V9ZM1.25 18V9C1.25 8.0335 2.0335 7.25 3 7.25C3.9665 7.25 4.75 8.0335 4.75 9V18C4.75 18.9665 3.9665 19.75 3 19.75C2.0335 19.75 1.25 18.9665 1.25 18Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/Newspaper.aef69e64a0430c24e9131706b8434393.svg";
export { ForwardRef as ReactComponent };